import { FormContainer, FormContainerProps } from 'src/UI/dynamicUI/layout/DeprecatedDynamicEntity';
import { Alert } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { InlineClickableText } from 'src/common/components/inline-clickable-text/InlineClickableText';
import { useConnectAsset } from 'src/financial/financial-data/hooks/useConnectAsset';
import PageLoader from 'src/UI/loader/PageLoader';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { useParams } from 'react-router-dom';

type FinancialFormContainerProps = {
  feedInfo: FeedInfo;
  onConnect?: (id: string) => void;
} & FormContainerProps;

export type FeedInfo = {
  isUpdatedAutomatically: boolean;
  hasFeedData: boolean;
};

export const FinancialFormContainer = (props: FinancialFormContainerProps) => {
  const { feedInfo } = props;
  const { isUpdatedAutomatically, hasFeedData } = feedInfo;
  const { id: assetId = '', clientId = '' } = useParams<{ id: string; clientId: string }>();
  const { connectAsset, isLoading } = useConnectAsset({ clientId });

  const handleConnectAsset = async () => {
    try {
      await connectAsset(assetId);
      props.onConnect?.(assetId);
    } catch (error) {
      notifyAndLogError(
        'Failed to connect asset to feed',
        'Something went wrong when trying to connect the feed. Please try again and if the problem persists, contact support.',
        error,
      );
    }
  };

  return (
    <FormContainer {...props}>
      {isLoading && <PageLoader />}
      {!isUpdatedAutomatically && hasFeedData && (
        <Alert
          variant="light"
          color="blue.4"
          radius="lg"
          icon={<IconInfoCircle color="var(--mantine-color-blue-4)" />}
          mb={'xxs'}
        >
          We found a data feed that matches this provider reference number. To keep this asset
          updated automatically,{' '}
          <InlineClickableText onClick={handleConnectAsset}>
            connect it to the feed
          </InlineClickableText>
          .
        </Alert>
      )}
      {props.children}
    </FormContainer>
  );
};
